(() => {
  if (window.luxsterHomeBlogCarouselReady) return;
  window.luxsterHomeBlogCarouselReady = true;
  const instances = new Map();

  function start(root) {
    root.querySelectorAll('.latest-blog--carousel').forEach(section => {
      if (instances.has(section)) return;
      const track = section.querySelector('.latest-blog__grid');
      const nav = section.querySelector('.latest-blog__nav');
      const previous = section.querySelector('[data-blog-previous]');
      const next = section.querySelector('[data-blog-next]');
      if (!track || !nav || !previous || !next) return;

      const update = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= end - 1;
        nav.hidden = end <= 1;
      };
      const move = direction => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: direction * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      };
      const backward = () => move(-1);
      const forward = () => move(1);
      previous.addEventListener('click', backward);
      next.addEventListener('click', forward);
      track.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();

      instances.set(section, () => {
        observer.disconnect();
        previous.removeEventListener('click', backward);
        next.removeEventListener('click', forward);
        track.removeEventListener('scroll', update);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, section) => {
      if (!event.target.contains(section)) return;
      destroy();
      instances.delete(section);
    });
  });
})();
